import React from "react";
import get from "lodash.get"; // Ensure lodash.get is installed: npm install lodash.get
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "@/components/ui/avatar";
import { Button } from "./ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "./ui/dropdown-menu";
import { MoreHorizontal } from "lucide-react";
import HandlePassword from "./HandlePassword";
import { Badge } from "./ui/badge";



type Action = {
    variant?: any; // Optional styling classes
    label: string; // Label for the button
    style?: string; // Optional styling classes
    handler: (row: any) => void; // Function to handle button click
};

type SetTableProps = {
    data: any[]; // Array of row data
    tableKeys: any[]; // Array of table headers and corresponding key paths
    actions?: Action[]; // Optional actions for each row
};

export function SetTable({ data, tableKeys, actions = [] }: SetTableProps) {

    return (
        <Table>
            {/* Table Header */}
            <TableHeader>
                <TableRow>
                    <TableHead className="font-bold text-black">#</TableHead>
                    <TableHead className="font-bold text-black">Profile</TableHead>
                    {tableKeys.map((keyObj, index) => (
                        <TableHead key={index} className="font-bold text-black capitalize">
                            {Object.keys(keyObj)[0]} {/* Get header name dynamically */}
                        </TableHead>
                    ))}
                    {actions.length > 0 && (
                        <TableHead className="font-bold text-black">Actions</TableHead>
                    )}
                </TableRow>
            </TableHeader>

            {/* Table Body */}
            <TableBody>
                {data?.map((item, index) => (
                    <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                            <Avatar>
                                <AvatarImage
                                    src={item?.profileImage || "https://github.com/shadcn.png"}
                                    alt={`Profile of ${item?.name || "User"}`}
                                />
                                <AvatarFallback>{item?.name?.charAt(0) || "U"}</AvatarFallback>
                            </Avatar>
                        </TableCell>
                        {tableKeys.map((keyObj, keyIndex) => {
                            const key = Object.values(keyObj)[0]; // Get the key path
                            const value = get(item, key as any, "N/A"); // Get the value using lodash.get
                            if (key === "plainTextPassword") {
                                return (
                                    <TableCell key={keyIndex}>
                                        <HandlePassword value={value} />
                                    </TableCell>
                                );
                            }
                            if (key === "isActive") {
                                return (
                                    <TableCell key={keyIndex}>
                                        <Badge color={value ? "success" : "error"}>
                                            {value ? "Active" : "Inactive"}
                                        </Badge>
                                    </TableCell>
                                );
                            }
                            return <TableCell key={keyIndex}>{value}</TableCell>;
                        })}
                        {actions.length > 0 && (
                            <TableCell>
                                <DropdownMenu>
                                    <DropdownMenuTrigger asChild>
                                        <Button variant="ghost" className="h-8 w-8 p-0">
                                            <span className="sr-only">Open menu</span>
                                            <MoreHorizontal />
                                        </Button>
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent align="end">
                                        {actions.map((action, actionIndex) => (
                                            // <Button
                                            //     key={actionIndex}
                                            //     className="m-1"
                                            //     variant={action.variant || "default"}

                                            //     onClick={() => action.handler(item)}
                                            // >
                                            //     {action.label}
                                            // </Button>
                                            <>
                                                <DropdownMenuItem
                                                    key={actionIndex}
                                                    onClick={() => action.handler(item)}
                                                >
                                                    {action.label}
                                                </DropdownMenuItem>
                                                <DropdownMenuSeparator />
                                            </>

                                        ))}
                                    </DropdownMenuContent>
                                </DropdownMenu>
                            </TableCell>
                        )}

                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
}